import { css } from 'styled-components';
export const BKJThemeToastMessage = {
    Success: css `
    background-color: #00c18c;
  `,
    Warning: css `
    background-color: #ed9d52;
  `,
    Error: css `
    background-color: #ce1037;
  `,
};
//# sourceMappingURL=BKJToastMessage.theme.js.map